import { Button } from '@mui/material'
import { useAuthContext } from 'components/context/AuthProvider'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import React from 'react'
import { useTeams } from '../../hooks/useTeams'
import { getAddMemberModalTitle } from './addMemberModalTitle'
import { TimelineTeamMemberFormAdd } from './TimelineTeamMemberFormAdd'

export function TimelineTeamMemberControlAdd() {
  const { isSharingEnabled } = useAuthContext()
  const {
    activeTeamId,
    activeTeamName,
    activeTeamType,
    teamMembersData,
    onRefetchTeamMembers,
    checkIsSystemManaged,
  } = useTeams()
  const [isOpen, handleOpen, handleClose] = useShowControl()

  const isSystemManagedTeam = checkIsSystemManaged(activeTeamId)

  return (
    <>
      <Button
        variant="contained"
        disabled={activeTeamId === null || !isSharingEnabled || isSystemManagedTeam}
        onClick={handleOpen}
      >
        Add Member
      </Button>

      <UIModal
        title={getAddMemberModalTitle(activeTeamName, activeTeamType)}
        width={800}
        isOpen={isOpen}
        onClose={handleClose}
      >
        {activeTeamId && (
          <TimelineTeamMemberFormAdd
            onClose={handleClose}
            teamId={activeTeamId}
            teamMembersData={teamMembersData}
            onRefetchTeamMembers={onRefetchTeamMembers}
          />
        )}
      </UIModal>
    </>
  )
}
